
import FlowUnordered from '@/components/block/FlowUnordered.vue'

export default {
  name: 'FlowRegisterEvents',

  props: {
    current: Number
  },

  components: {
    FlowUnordered
  },

  setup() {
    const items = [
      {
        label: '会員区分<br>選択',
        current: false
      },
      {
        label: '希望条件<br>選択',
        current: false
      },
      {
        label: '登録方法<br>選択・入力',
        current: false
      },
      {
        label: '登録内容<br>確認',
        current: false
      },
      {
        label: '申込み<br>登録完了',
        current: false
      }
    ]

    return {
      items
    }
  }
}
